import { Component } from "react";
import { Paths } from "./../../constants/UrlConstants";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { keepAlive } from "./../../services/KeepAliveService";
import { NetworkTimeout } from "./../../constants/Constants";

export const userRedirectedThroughTimeoutRedirect =
  "User redirected through timeout redirect page";

export const mapStateToTimeoutRedirect = ({
  accountReducer = {},
  networkStateReducer = {}
}) => {
  return {
    isTimedOut: accountReducer.isTimedOut,
    isLoggedIn: accountReducer.isLoggedIn,
    lastRequestedTime: networkStateReducer.lastRequestedTime,
    lastInteractionTime: networkStateReducer.lastInteractionTime,
    systemUnavailable: networkStateReducer.systemUnavailable
  };
};

function checkTimeout() {
  if (this.props.isTimedOut && this.props.location.pathname !== Paths.Timeout) {
    this.props.history && this.props.history.replace(Paths.Timeout);
  }
}

function checkSystemAvailability() {
  if (
    this.props.systemUnavailable &&
    this.props.location.pathname !== Paths.SystemUnavailable
  ) {
    this.props.history && this.props.history.replace(Paths.SystemUnavailable);
  }
}

export class TimeoutRedirect extends Component {
  componentDidMount() {
    checkTimeout.apply(this);
    checkSystemAvailability.apply(this);
  }

  componentDidUpdate(prevProps) {
    checkTimeout.apply(this);
    checkSystemAvailability.apply(this);

    const canKeepAlive =
      this.props.isLoggedIn &&
      this.props.lastRequestedTime > 1 &&
      new Date().getTime() - this.props.lastRequestedTime >= NetworkTimeout &&
      ((prevProps.location &&
        this.props.location &&
        prevProps.location.pathname !== this.props.location.pathname) ||
        (this.props.lastInteractionTime > 1 &&
          prevProps.lastInteractionTime !== this.props.lastInteractionTime));

    if (canKeepAlive) {
      keepAlive();
    }
  }

  render() {
    return null;
  }
}

export default withRouter(connect(mapStateToTimeoutRedirect)(TimeoutRedirect));
